module.exports = __webpack_public_path__ + "static/media/complete_alert_icon.0ff24849.png";